const toText = (value) => (value === undefined || value === null ? "" : `${value}`);

export const getHeadingContentByKey = (headingContents = [], headingKey = "") => {
  if (!Array.isArray(headingContents) || !headingKey) {
    return "";
  }

  const matchedHeading = headingContents.find((item) => item && item.heading_key === headingKey);
  return matchedHeading && typeof matchedHeading.heading_content === "string" ? matchedHeading.heading_content : "";
};

export const resolveParticipantName = (participant = {}) => {
  if (participant && participant.staff_name) {
    return participant.staff_name;
  }

  if (participant && participant.added_on_the_fly && participant.added_person_name) {
    return participant.added_person_name;
  }

  return "";
};

export const getAnswerByQuestionId = (answers = [], questionId) => {
  if (!Array.isArray(answers)) {
    return null;
  }

  return answers.find((answer) => Number(answer && answer.question_id) === Number(questionId)) || null;
};

export const formatAnswerValue = (question = {}, answer = null) => {
  if (!answer) {
    return "";
  }

  const responseConfig = question && question.response_config ? question.response_config : {};
  const responseType = responseConfig.type;
  const rawValue = answer.value;

  if (rawValue === undefined || rawValue === null || rawValue === "") {
    return "";
  }

  if (responseType === "radio") {
    const options = Array.isArray(responseConfig.options) ? responseConfig.options : [];
    const matchedOption = options.find((option) => option && option.value === rawValue);
    return matchedOption && matchedOption.label ? matchedOption.label : toText(rawValue);
  }

  if (responseType === "number") {
    const unit = responseConfig && typeof responseConfig.unit === "string" ? responseConfig.unit.trim() : "";
    return unit ? `${toText(rawValue)} ${unit}` : toText(rawValue);
  }

  if (responseType === "signature" || responseType === "photo") {
    if (typeof rawValue === "string") {
      return rawValue;
    }

    if (rawValue && typeof rawValue === "object") {
      return rawValue.sign_url || rawValue.url || "";
    }
  }

  return toText(rawValue);
};
